import { assign, setup } from 'xstate';
import {
  MachineContext,
  MachineInput,
  MachineEvents,
  ShippingMethod,
} from './types';
import { selectorMachine } from '../selectorMachine';
import { ShippingMethodTypes } from '@monofront/types';
import { EVENTS } from './events';
import { STATES } from './states';
import { ACTIONS } from './actions';

export const machine = setup({
  types: {
    context: {} as MachineContext,
    input: {} as MachineInput,
    events: {} as MachineEvents,
  },
  actions: {
    [ACTIONS.SELECT]: assign({
      shippingMethod: ({ context, event }) => {
        const previous = context?.shippingMethod;

        if (!previous && !event.value) {
          return undefined;
        }

        return {
          ...previous,
          ...event.value,
        } as ShippingMethod;
      },
    }),
  },
  actors: {
    shippingMethodSelectorMachine: selectorMachine,
  },
}).createMachine({
  id: 'shipping-method-selector-machine',
  initial: STATES.NOT_SELECTED,
  context: {
    shippingMethod: undefined,
  },

  states: {
    [STATES.NOT_SELECTED]: {
      on: {
        [EVENTS.SELECT]: [
          {
            guard: ({ event }) =>
              event.value?.type === ShippingMethodTypes.PICKUP,
            actions: ACTIONS.SELECT,
            target: STATES.PICKUP_POINT_SELECTION,
          },
          {
            actions: ACTIONS.SELECT,
            target: STATES.SELECTED,
          },
        ],
      },
    },

    [STATES.PICKUP_POINT_SELECTION]: {
      on: {
        [EVENTS.SELECT]: {
          actions: ACTIONS.SELECT,
          target: STATES.SELECTED,
        },
      },
    },

    [STATES.SELECTED]: {
      type: 'final',
    },
  },
  output: ({ context }) => context,
});
